import { render } from "./vueModal.vue?vue&type=template&id=6046f82b&scoped=true"
import script from "./vueModal.vue?vue&type=script&lang=js"
export * from "./vueModal.vue?vue&type=script&lang=js"

import "./vueModal.vue?vue&type=style&index=0&id=6046f82b&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6046f82b"]])

export default __exports__